import { createFileRoute } from '@tanstack/react-router';
import { RotinasBancarias } from '@/features/cobranca-boleto/page/rotinas-bancarias/RotinasBancarias';

export const Route = createFileRoute('/a/cobranca-boleto/rotinas-bancarias')({
    component: RotinasBancarias,
});
